let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7eb4c")).then(() => parcelRequire('dPsCl'));